import React from 'react'
import { Dropdown } from 'primereact/dropdown'

import '../CustomDropdown/CustomDropdown.css'

export default function CustomDropdownWithFilter({
  optionLabel,
  optionValue,
  dataKey,
  options = [],
  value,
  onChange,
  label,
  filterMatchMode = 'contains',
  filter = false,
  disabled = false,
  showLabel = true,
  marginTop = 9,
  placeholder = '',
  labelPosition = 'top',
  itemTemplate = null,
  tooltip = undefined,
}) {
  const resolvedDataKey = dataKey || optionValue || 'id'

  return (
    <div className={`CustomDropdown label-position-${labelPosition}`} style={{ marginTop }}>
      {showLabel ? <label className="dropdown-label">{label}</label> : null}
      {itemTemplate ? (
        <Dropdown
          filterMatchMode={filterMatchMode}
          itemTemplate={itemTemplate}
          placeholder={placeholder}
          scrollHeight="100px"
          filter={filter}
          disabled={disabled}
          value={value}
          optionLabel={optionLabel}
          dataKey={resolvedDataKey}
          options={options}
          onChange={e => onChange(e.value)}
          tooltip={tooltip}
          resetFilterOnHide={true}
          virtualScrollerOptions={{ itemSize: 38 }}
        />
      ) : (
        <Dropdown
          filterMatchMode={filterMatchMode}
          placeholder={placeholder}
          scrollHeight="100px"
          filter={filter}
          disabled={disabled}
          value={value}
          optionLabel={optionLabel}
          dataKey={resolvedDataKey}
          options={options}
          onChange={e => onChange(e.value)}
          tooltip={tooltip}
          resetFilterOnHide={true}
          virtualScrollerOptions={{ itemSize: 38 }}
        />
      )}
    </div>
  )
}
